import { isReviewApp } from './environmentChecker';

export const isCaptchaEnv = () =>
  !isReviewApp() && !!process.env.APP_ENV && !process.env.IS_E2E_TEST;
